import React from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'

export const UploadingImages = ({ handleFileChange, src, hasError }) => {
  return (
    <Horizontal verticalCenter justifyContent={'start'}>
      <Vertical flex={1} alignItems={'start'}>
        <label htmlFor='myImage'>
          {src ? (
            <div className={'custom-file-uploader'}>
              <img alt='image' className={'uploaded-image'} src={src} />
            </div>
          ) : (
            <>
              <Vertical
                className={hasError ? 'custom-file-uploader-errored' : 'custom-file-uploader'}
                verticalCenter
                horizontalCenter
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </Vertical>
              {hasError && (
                <Texto appearance={'error'} style={{ fontSize: '10px' }}>
                  Add an image
                </Texto>
              )}
            </>
          )}
        </label>
        <input type='file' id='myImage' onChange={(event) => handleFileChange(event.target.files[0])} />
      </Vertical>
      <Vertical flex={1.8}>
        <Texto>Preferred Image</Texto>
        <Texto>JPG, SVG or Transparent PNG 256px * 256px </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto>Max File Size</Texto>
        <Texto>1MB </Texto>
      </Vertical>
    </Horizontal>
  )
}
